<template>
  <div class="personnel-on-duty-schedule-manage">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex;justify-content: flex-start;align-items: center;">
        <button-add :pathName="addAccountRouterName" :value="addBtnValue" v-if="permissionCodes.indexOf('004037001') !== -1"/>
      </div>
      <input-search :placeholder="searchPlaceholder" @search="search" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @getDeviceCodeTip="getDeviceCodeTip" @goToModifyPage="goToModifyPage" @deleteLine="deleteLine" :deleteTipInfo="deleteTipInfo" :operationArr="operationArr" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />

    <el-dialog title="应急求助二维码" :visible.sync="parkingHelpDialogVisible" width="40%">
      <div style="margin: 20px 0;" ref="imageWrapper">
        <canvas class="qrcode" ref="qrCodeUrl" id="createCode"></canvas>
        <div style="width: 280px;margin: 0 auto;text-align: center;font-size: 18px;" >{{currentDeviceName}}</div>
      </div>
      <el-button size="small" plain @click="setImage">保存图片</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="parkingHelpDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../../components/Button/ButtonAdd";
import InputSearch from "../../../../components/Input/InputSearch";
import TableMain from "../../../../components/Table/TableMain";
import { api } from "../../../api/ParkingService";
import { errorHandler } from "../../../../utils/errorHandler";
import { nSuccess } from "../../../../utils/notice";
import { bus } from "../../../../utils/bus";
import ButtonCancel from "../../../../components/Button/ButtonCancel";
import QrCodeWithLogo from "qr-code-with-logo";
import html2canvas from "html2canvas";

export default {
  components: {
    ButtonCancel,
    TableMain,
    InputSearch,
    ButtonAdd,
    Breadcrumb
  },
  name: "personnel-on-duty-schedule-manage",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {value: "智慧停车", name: "parking-device-management"},
        {value: "排班管理"}
      ],
      addAccountRouterName: "personnel-on-duty-schedule-add",
      addBtnValue: "添加排班",
      searchPlaceholder: "出入口设备名称",
      searchKey: "",
      deleteTipInfo: "是否确认删除该排班信息？",
      tableHead: [
        {prop: "deviceName", label: "出入口设备名称"},
        {prop: "deviceCode", label: "出入口设备编号"},
        {prop: "personName", label: "值班人员姓名"},
        {prop: "personPhone", label: "值班人员手机号"},
        {prop: "routeName", label: "班次名称"}
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      operationArr: ["deviceCodeTip", "modify", "delete"],

      parkingHelpDialogVisible: false,
      currentDeviceName: '',
      tipContent: ''
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  activated() {
    this.getPage();
  },
  methods: {
    getPage() {
      this.$axios.post(api.getParkingEmergencyRoutePlanPage, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          searchKey: this.searchKey
        })
        .then(res => {
          this.total = res.data.data.total;
          let data = res.data.data.list;
          this.tableData = data;
        })
        .catch(errorHandler("获取数据失败"));
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    search(v) {
      this.pageNum = 1;
      this.searchKey = v;
      this.getPage();
    },
    // 修改
    goToModifyPage(code) {
      this.$router.push({
        path: `/park_server/personnel_on_duty_schedule_modify/${code}`
      });
    },
    // 删除
    deleteLine(code) {
      this.$axios.post(api.deleteParkingEmergencyRoutePlanByCodes, code)
        .then(res => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    },

    getDeviceCodeTip (data) {
      this.tipContent = `https://yq.damaiiot.com/yq/smallProgram/parkingHelp/?yqCode=${bus.global.yqCode}&deviceCode=${data.deviceCode}&deviceName=${data.deviceName}`;
      this.currentDeviceName = data.deviceName;
      this.getCodes();
      this.parkingHelpDialogVisible = true;
    },

    getCodes() {
      setTimeout(() => {
        QrCodeWithLogo.toCanvas({
          canvas: document.getElementById("createCode"),
          content: this.tipContent,
          width: 400
        }).catch();
      }, 100);
    },

    setImage() {
      let that = this;
      html2canvas(this.$refs.imageWrapper).then(canvas => {
        let image = canvas.toDataURL("image/jpeg");
        let $a = document.createElement("a");
        $a.setAttribute("href", image);
        $a.setAttribute("download", that.currentElectricDeviceName);
        $a.click();
      });
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/PersonnelOnDuty/PersonnelOnDutySchedule/PersonnelOnDutyScheduleManage.vue